import { emitToggleSearch } from "../events";
import type { Binding } from "../types";

/**
 * Routes with no workspace behind them.
 *
 * Search queries a single workspace, so outside one there is nothing for it to
 * look through. The workspace picker is the case that matters most: a workspace
 * stays cached in sessionStorage while you are choosing a different one, so
 * "is a workspace selected" reports true there and cannot be used to tell the
 * two situations apart. The route can.
 *
 * Checked at keystroke time, so client-side navigation is always reflected.
 */
const NON_WORKSPACE_ROUTES = [
  "/organization/workspace", // picking a workspace — none is active yet
  "/signup",
  "/user",
  "/403",
  "/privacy",
  "/terms",
  "/public/note", // public viewer; the reader has no workspace at all
];

function isInsideWorkspace(): boolean {
  if (typeof window === "undefined") return false;
  const path = window.location.pathname;
  return !NON_WORKSPACE_ROUTES.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
}

export const globalBindings: Binding[] = [
  {
    id: "global.search",
    keys: "Mod+K",
    scope: "global",
    label: "Search",
    group: "Navigation",
    // Fires from anywhere, including while typing in a plain field — the old
    // window listener behaved this way and people rely on it.
    allowInInput: true,
    // Declining here rather than opening an empty modal also leaves the
    // keystroke alone: dispatch only calls preventDefault on a real match, so
    // the browser keeps whatever ⌘K normally does on these pages.
    when: isInsideWorkspace,
    run: () => {
      emitToggleSearch();
    },
  },
];
